import React, { FC, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useTransLog } from '../contexts/TransLogContext';
import { DataListTable, HeadCell } from './DataListTable';
import { SapTransactionStatistics } from '../models/SapTransLog';

const columns: HeadCell[] = [
    { id: 'transactionType', label: 'Transaction Name' },
    { id: 'year', label: 'Year' },
    { id: 'month', label: 'Month' },
    { id: 'day', label: 'Day' },
    { id: 'avgDuration', label: 'Avg Duration(s)', valueGetter: (row: SapTransactionStatistics) => row.avgDuration.toFixed(2) },
    { id: 'maxDuration', label: 'Max Duration(s)', valueGetter: (row: SapTransactionStatistics) => row.maxDuration.toFixed(2) },
    { id: 'minDuration', label: 'Min Duration(s)', valueGetter: (row: SapTransactionStatistics) => row.minDuration.toFixed(2) },
    { id: 'volume', label: 'Volume' },
];

const TransactionStatisticsModal = ({ show, handleClose }: { show: boolean, handleClose: () => void }) => {
    const { statisticsReport, searching } = useTransLog();

    return (
        <>
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Transaction Statistics</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {searching ? <><h2>Loading...</h2></> :
                        <Container fluid className="mt-3 mb-3 layout-container">
                            <DataListTable clickableRowIds={[]} headCells={columns} dataSource={statisticsReport} />
                        </Container>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TransactionStatisticsModal;